import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { getOnboardingServicesUrl } from '../../../utils/publicUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getOnboardingMessageKey(productLevel) {
  switch (productLevel) {
    case 'PROFESSIONAL':
      return 'publicPricingPage.merchCard.footer.onboardingWithPriceProfessional';
    case 'ENTERPRISE':
      return 'publicPricingPage.merchCard.footer.onboardingWithPriceEnterprise';
    default:
      return undefined;
  }
}
function buildStarterDiscountDisclaimer(card) {
  if (card.productLevel !== 'STARTER') return null;
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-200",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.merchCard.footer.starterDiscountDisclaimer"
    })
  });
}
function buildOnboardingDisclaimer(card, currencyCode) {
  var _onboarding$onboardin, _option$bestPrice;
  if (card.featureDisplay.type === 'bundledHubs') return null;
  const onboarding = card.requiredOnboarding;
  if (!onboarding || !onboarding.required) return null;
  const option = (_onboarding$onboardin = onboarding.onboardingOptions) === null || _onboarding$onboardin === void 0 ? void 0 : _onboarding$onboardin[0];
  const rawPrice = option === null || option === void 0 || (_option$bestPrice = option.bestPrice) === null || _option$bestPrice === void 0 ? void 0 : _option$bestPrice.priceForCommittedPeriod;
  const onboardingPrice = rawPrice ? parseFloat(rawPrice) : undefined;
  const learnMoreLink = /*#__PURE__*/_jsx(Link, {
    href: getOnboardingServicesUrl(),
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.merchCard.footer.learnMore"
    })
  });
  const messageKey = getOnboardingMessageKey(typeof card.productLevel === 'string' ? card.productLevel : undefined);
  if (messageKey && onboardingPrice !== undefined && !Number.isNaN(onboardingPrice)) {
    return /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: messageKey,
        options: {
          price: /*#__PURE__*/_jsx(PriceDisplay, {
            price: onboardingPrice,
            currencyCode: currencyCode,
            round: false
          }),
          learnMoreLink
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-200",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "publicPricingPage.merchCard.footer.onboardingGeneric",
      options: {
        learnMoreLink
      }
    })
  });
}
export const PublicMerchCardFooter = ({
  card,
  currencyCode
}) => {
  const starterDiscountDisclaimer = buildStarterDiscountDisclaimer(card);
  const onboardingDisclaimer = buildOnboardingDisclaimer(card, currencyCode);
  if (!starterDiscountDisclaimer && !onboardingDisclaimer) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [starterDiscountDisclaimer, onboardingDisclaimer]
  });
};